module.exports = __webpack_public_path__ + "img/blaked-cbd-stars.d246849d.png";